import { useFeature } from "~hooks/useFeature";
import { CrowdCoursingLogo, SpaceFloridaFullLogo, SpaceFloridaNavLogo } from "~ui/atoms/Icons";

export type AppLogoVariant = "logoWithTagline" | "navBarLogo";

export interface AppLogoProps {
  logo?: AppLogoVariant;
  style?: { height?: string };
}

/** Brand logo (CrowdCoursing vs Space Florida) driven by feature flags. */
export function AppLogo({ logo = "navBarLogo", style }: AppLogoProps) {
  const sx = {
    height: style?.height ? `${style.height} !important` : "auto",
    width: style?.height ? "auto" : "100%",
  };
  const isSpaceFlorida = useFeature("isSpaceFlorida");
  if (isSpaceFlorida) {
    if (logo === "navBarLogo") {
      return <SpaceFloridaNavLogo sx={sx} />;
    }
    return <SpaceFloridaFullLogo sx={sx} />;
  }
  return <CrowdCoursingLogo sx={sx} />;
}
